import { englishMaterialAlias, englishMaterialName } from "./materialNames";
import { sumQuantities } from "./marbleQuantity";

export function normalizeDuplicateName(value) {
  return String(value || "").normalize("NFKD").toLowerCase()
    .replace(/\p{M}|\u0640/gu, "")
    .replace(/[\u0622\u0623\u0625]/g, "\u0627")
    .replace(/\u0649/g, "\u064a").replace(/\u0629/g, "\u0647")
    .replace(/\u0624/g, "\u0648").replace(/\u0626/g, "\u064a")
    .replace(/[^\p{L}\p{N}\s]/gu, "").replace(/\s+/g, " ").trim();
}

export function findMaterialDuplicates(name, materials, excludeId = null) {
  const keys = new Set([name, englishMaterialAlias(name)].map(normalizeDuplicateName).filter(Boolean));
  const aliases = [
    ["carrara", "كراره", "كرارا"], ["perlato", "بيرلاتو", "برلاتو"],
    ["rosso", "روسو"], ["nero", "نيرو", "اسود"], ["bianco", "بيانكو", "ابيض"],
  ].map(group => group.map(normalizeDuplicateName));
  for (const group of aliases) {
    if (group.some(key => keys.has(key))) group.forEach(key => keys.add(key));
  }
  return materials.filter(material => String(material.id) !== String(excludeId) &&
    [material.name, material.material_name, material.name_en, englishMaterialName(material)]
      .some(label => label && !label.includes("(English name needed)") && keys.has(normalizeDuplicateName(label))));
}

export async function readDuplicateRows(client, table, columns, filter = query => query) {
  const rows = [];
  for (let start = 0; ; start += 1000) {
    const {data, error} = await filter(client.from(table).select(columns).order("id").range(start, start + 999));
    if (error) throw error;
    rows.push(...(data || []));
    if (!data || data.length < 1000) return rows;
  }
}

export const readDuplicateMaterials = client => readDuplicateRows(client, "material", "id,name,name_en");

export async function findBlockDuplicates(client, product, excludeId = null) {
  const candidates = await readDuplicateRows(client, "block", "id,code,material_id,customer_id,width,height,thickness,slabs_number",
    query => query.eq("material_id", product.material_id).eq("customer_id", product.customer_id));
  const matches = candidates.filter(block => String(block.id) !== String(excludeId) &&
    ["width", "height", "thickness"].every(key => Number(block[key] || 0) === Number(product[key] || 0)));
  const stockByBlock = new Map();
  for (let start = 0; start < matches.length; start += 100) {
    const ids = matches.slice(start, start + 100).map(block => block.id);
    const rows = await readDuplicateRows(client, "block_distribution", "id,block_id,slabs_count", query => query.in("block_id", ids));
    for (const row of rows) {
      const id = String(row.block_id);
      if (!stockByBlock.has(id)) stockByBlock.set(id, []);
      stockByBlock.get(id).push(row.slabs_count);
    }
  }
  return matches.filter(block => {
    const stock = stockByBlock.get(String(block.id));
    return (stock ? sumQuantities(stock) : Number(block.slabs_number)) === Number(product.slabs_number);
  });
}
